<template>
  <div class="hub drawers">
    <CreateTaskDrawer />
    <ProjectBriefingDrawer />
    <CreateProjectDrawer />
    <CreateContractDrawer />
    <CreateCampaignDrawer />
  </div>
</template>

<script>
import {
  CreateTaskDrawer,
  ProjectBriefingDrawer,
  CreateProjectDrawer,
  CreateContractDrawer,
  CreateCampaignDrawer,
} from './'
export default {
  components: {
    CreateTaskDrawer,
    ProjectBriefingDrawer,
    CreateProjectDrawer,
    CreateContractDrawer,
    CreateCampaignDrawer,
  },
}
</script>

<style lang="scss" scoped></style>
